<template>
    <div class="artesvisuais">
        <h1>{{ title }}</h1> 
        <h1>{{subtitle}}</h1>
        <h2>{{course}}</h2>
        
        <TabView class="tabview-custom">
            <TabPanel>
                <template slot="header">
                    <i class="pi pi-calendar"></i>
                    <span>Fortaleza</span>
                </template>
                <DataTable class="p-datatable-responsive" :value="dadosPlanilha1" :filters="filters" :paginator="true" :rows="10">
                <template #header>
                    <div style="text-align: right">
                        <i class="pi pi-search" style="margin: 4px 10px 0 0"></i>
                        <InputText v-model="filters['global']" placeholder="Pesquise aqui" size="auto" />
                    </div>
                </template>
                <Column field="0" header="Nome">
                    <template>
                        <InputText type="text" v-model="filters['nome']" />    
                    </template>
                </Column>
                <Column field="1" header="Polo">
                    <template>
                        <InputText type="text" v-model="filters['polo']"  />  
                    </template>
                </Column>
                <Column field="8" header="Resultado">
                    <template >
                        <InputText type="text" v-model="filters['resultado']"  />    
                    </template>
                </Column>
                <Column field="9" header="Observação">
                    <template >
                        <InputText type="text" v-model="filters['observacao']"  />    
                    </template>
                </Column>
                <template #empty>
                Nada encontrado.
                </template>
            </DataTable>
        </TabPanel>
        <TabPanel>
                <template slot="header">
                    <i class="pi pi-calendar"></i>
                    <span>Jaguaribe</span>
                </template>
                <DataTable class="p-datatable-responsive" :value="dadosPlanilha2" :filters="filters" :paginator="true" :rows="10">
                <template #header>
                    <div style="text-align: right">
                        <i class="pi pi-search" style="margin: 4px 10px 0 0"></i>
                        <InputText v-model="filters['global']" placeholder="Pesquise aqui" size="auto" />
                    </div>
                </template>
                <Column field="0" header="Nome">
                    <template>
                        <InputText type="text" v-model="filters['nome']" />    
                    </template>
                </Column>
                <Column field="1" header="Polo">
                    <template>
                        <InputText type="text" v-model="filters['polo']"  />  
                    </template>
                </Column>
                <Column field="8" header="Resultado">
                    <template >
                        <InputText type="text" v-model="filters['resultado']"  />    
                    </template>
                </Column>
                <Column field="9" header="Observação">
                    <template >
                        <InputText type="text" v-model="filters['observacao']"  />    
                    </template>
                </Column>
                <template #empty>
                Nada encontrado.
                </template>
            </DataTable>
        </TabPanel>
        <TabPanel>
                <template slot="header">
                    <i class="pi pi-calendar"></i>
                    <span>Maracanau</span>
                </template>
                <DataTable class="p-datatable-responsive" :value="dadosPlanilha3" :filters="filters" :paginator="true" :rows="10">
                <template #header>
                    <div style="text-align: right">
                        <i class="pi pi-search" style="margin: 4px 10px 0 0"></i>
                        <InputText v-model="filters['global']" placeholder="Pesquise aqui" size="auto" />
                    </div>
                </template>
                <Column field="0" header="Nome">
                    <template>
                        <InputText type="text" v-model="filters['nome']" />    
                    </template>
                </Column>
                <Column field="1" header="Polo">
                    <template>
                        <InputText type="text" v-model="filters['polo']"  />  
                    </template>
                </Column>
                <Column field="8" header="Resultado">
                    <template >
                        <InputText type="text" v-model="filters['resultado']"  />    
                    </template>
                </Column>
                <Column field="9" header="Observação">
                    <template >
                        <InputText type="text" v-model="filters['observacao']"  />    
                    </template>
                </Column>
                <template #empty>
                Nada encontrado.
                </template>
            </DataTable>
        </TabPanel>
        <TabPanel>
                <template slot="header">
                    <i class="pi pi-calendar"></i>
                    <span>Quixeramobim</span>
                </template>
                <DataTable class="p-datatable-responsive" :value="dadosPlanilha4" :filters="filters" :paginator="true" :rows="10">
                <template #header>
                    <div style="text-align: right">
                        <i class="pi pi-search" style="margin: 4px 10px 0 0"></i>
                        <InputText v-model="filters['global']" placeholder="Pesquise aqui" size="auto" />
                    </div>
                </template>
                <Column field="0" header="Nome">
                    <template>
                        <InputText type="text" v-model="filters['nome']" />    
                    </template>
                </Column>
                <Column field="1" header="Polo">
                    <template>
                        <InputText type="text" v-model="filters['polo']"  />  
                    </template>
                </Column>
                <Column field="8" header="Resultado">
                    <template >
                        <InputText type="text" v-model="filters['resultado']"  />    
                    </template>
                </Column>
                <Column field="9" header="Observação">
                    <template >
                        <InputText type="text" v-model="filters['observacao']"  />    
                    </template>
                </Column>
                <template #empty>
                Nada encontrado.
                </template>
            </DataTable>
        </TabPanel>
        <TabPanel>
                <template slot="header">
                    <i class="pi pi-calendar"></i>
                    <span>Sobral</span>
                </template>
                <DataTable class="p-datatable-responsive" :value="dadosPlanilha5" :filters="filters" :paginator="true" :rows="10">
                <template #header>
                    <div style="text-align: right">
                        <i class="pi pi-search" style="margin: 4px 10px 0 0"></i>
                        <InputText v-model="filters['global']" placeholder="Pesquise aqui" size="auto" />
                    </div>
                </template>
                <Column field="0" header="Nome">
                    <template>
                        <InputText type="text" v-model="filters['nome']" />    
                    </template>
                </Column>
                <Column field="1" header="Polo">
                    <template>
                        <InputText type="text" v-model="filters['polo']"  />  
                    </template>
                </Column>
                <Column field="8" header="Resultado">
                    <template >
                        <InputText type="text" v-model="filters['resultado']"  />    
                    </template>
                </Column>
                <Column field="9" header="Observação">
                    <template >
                        <InputText type="text" v-model="filters['observacao']"  />    
                    </template>
                </Column>
                <template #empty>
                Nada encontrado.
                </template>
            </DataTable>
        </TabPanel>
     </TabView>
    </div>
</template>

<script>
import SheetsServices from '@/services/servicosArtes'

export default {
name: 'Matematica',
    props: {
        title: String,
        subtitle: String,
        course: String,
    },  
data() {
    return {
        filters: {},
        // rowData: (),
        dadosPlanilha1: null,
        dadosPlanilha2: null,
        dadosPlanilha3: null,
        dadosPlanilha4: null,
        dadosPlanilha5: null,
    }
}, 
    sheetsService: null,
    created() {
        this.sheetsService = new SheetsServices()
        },
    mounted() {
        this.sheetsService.getFortaleza().then(data => this.dadosPlanilha1 = data.values)
        this.sheetsService.getJaguaribe().then(data => this.dadosPlanilha2 = data.values);
        this.sheetsService.getMaracanau().then(data => this.dadosPlanilha3 = data.values);
        this.sheetsService.getQuixeramobim().then(data => this.dadosPlanilha4 = data.values);
        this.sheetsService.getSobral().then(data => this.dadosPlanilha5 = data.values);
    }
}

</script>

<style lang="scss">
.tabview-custom {
	i, span {
		vertical-align: middle;
	}

	span {
		margin: 0 .5rem;
	}
}
    .p-filter-column {
        .p-dropdown, .p-inputtext {
            width: 100%;
        }
    }

    .p-column-title {
        float: left;
        margin-top: .125rem;
        font-weight: 100%; 
    }
</style>